module.exports = __webpack_public_path__ + "static/media/building.2a83d027.jpg";